import React from 'react';
import paymentCareCredit from '../../../assets/images/payment/carecredit.png';
import lock from '../../../assets/images/payment/paymentLock.png';
import GradientButton from '../../../components/atoms/GradientButton';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import { Link } from 'react-router-dom';

const PaymentSection = () => {
  return (
    <section className="bg-[#EBF2FB]" id="payment-section">
      <main className="relative max-w-[1200px] mx-auto h-full px-4 md:px-10 py-8 md:py-24 z-10">
        <h4 className="text-[34px] sm:text-[45px] md:text-[50px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] max-w-[700px]">
          How to Pay
        </h4>
        <p className="text-[24px] sm:text-[28px] md:text-[32px] text-[#7B54A2] font-semibold leading-tight mt-6">
          Guidepost Pediatrics provides a secure online payment option for your
          convenience. Please use the link below to access our payment portal
          and submit payment for services received.
        </p>
        <p className="text-[24px] sm:text-[28px] md:text-[32px] text-[#7B54A2] font-semibold leading-tight mt-8 mb-6">
          All transactions are encrypted and processed securely.
        </p>
        <GradientButton
          text="Make Payment"
          icon={lock}
          // width={"w-full sm:w-[150px]"}
          padding="flex py-2 md:py-0 items-center self-center"
          height="h-[38px]"
          navigateTo={
            'https://6a84f235-f5b5-4b1c-8fb4-fa79c9474500.paylinks.godaddy.com/b6594f9a-314d-4cf2-a221-7f8'
          }
        />
        <div className="flex flex-col md:flex-row gap-10 md:gap-20 mt-10 sm:mt-20">
          <div className="flex-1 rounded-3xl">
            <h2 className="text-[26px] sm:text-[32px] text-primary font-bold">
              Financing Option
            </h2>
            <img
              src={paymentCareCredit}
              alt="paymentCareCredit"
              className="mt-9 mb-4"
            />
            <p className="text-lg text-[#515251] font-light max-w-auto sm:max-w-[480px] ">
              We accept CareCredit to help families manage out-of-pocket
              healthcare costs. If you have an existing CareCredit account, you
              may use it for services at our clinic.
            </p>
            <p className="text-lg text-[#515251] font-light max-w-auto sm:max-w-[480px] my-4">
              Interested in applying? Click below to learn more or to apply
              online:
            </p>
            <GradientOutlineButton
              text="Apply for CareCredit"
              navigateTo={'https://www.carecredit.com/apply/'}
            />
          </div>
          <div className="flex-1 flex flex-col gap-3">
            <h2 className="text-[26px] sm:text-[32px] text-primary font-bold">
              Questions?
            </h2>
            <p className="text-lg text-[#515251] font-light max-w-[400px] leading-8 ">
              If you need help with billing, payment plans, or using CareCredit,
              please contact our office:
            </p>
            <p className="text-lg text-[#515251] max-w-auto font-bold mt-4 ">
              <a href="tel:phone " className="text-[#553B8A] text-[40px] ">
                907-376-4880
              </a>{' '}
              <br />
              or{' '}
              <Link to="/contact" className="text-primary">
                Send Us a Message
              </Link>
            </p>
          </div>
        </div>
      </main>
    </section>
  );
};

export default PaymentSection;
